// extracted by mini-css-extract-plugin
module.exports = {"status-text":"App_status-text__1TSKQ","error-text":"App_error-text__3r7Iq"};